import React, { useEffect } from "react";
import { Button, Checkbox, Icon, List, Popup } from "semantic-ui-react";
const Filters = ({
  categoryIdsFilter,
  setFilter,
  subjects,
  subjectIdsFilter,
  themeIdsFilter,
  themes
}) => {
  useEffect(() => {
    let subjectIds = [];
    themeIdsFilter.forEach(themeId => {
      let theme = themes[themeId];
      if (theme && subjectIds.indexOf(theme.subjectId) === -1) {
        subjectIds.push(theme.subjectId);
      }
    });
    setFilter('subjectIds', subjectIds);
  }, [themeIdsFilter, themes, setFilter]);
  return subjects && Object.keys(subjects).length ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "resources-menu"
  }, " ", Object.keys(subjects).map(subjectId => {
    let subject = subjects[subjectId];
    let checkedSubject = false;
    if (subjectIdsFilter && subjectIdsFilter.indexOf(subject.id) !== -1) {
      checkedSubject = true;
    }
    return subject.children.length ? /*#__PURE__*/React.createElement(Popup, {
      className: "resources-dropdown-popup",
      trigger: /*#__PURE__*/React.createElement(Button, {
        className: "resources-resources-dropdown-button",
        icon: true
      }, /*#__PURE__*/React.createElement("span", {
        className: checkedSubject ? "resources-subject-checked" : ""
      }, /*#__PURE__*/React.createElement("span", null, subject.label), /*#__PURE__*/React.createElement(Icon, {
        name: 'angle down'
      }), /*#__PURE__*/React.createElement("span", {
        className: "separator"
      }, "|"))),
      position: "bottom left",
      hoverable: true,
      pinned: true,
      offset: [0, -1],
      key: subjectId
    }, /*#__PURE__*/React.createElement("div", {
      className: "resources-dropdown-options"
    }, /*#__PURE__*/React.createElement(List, {
      className: "resources-dropdown-options-list"
    }, subject.children.map(themeId => {
      let theme = themes[themeId];
      let checked = false;
      if (themeIdsFilter && themeIdsFilter.indexOf(theme.id) !== -1) {
        checked = true;
      }
      return /*#__PURE__*/React.createElement(List.Item, {
        key: themeId
      }, /*#__PURE__*/React.createElement(Checkbox, {
        className: "resources-dropdown-options-option",
        label: theme.label,
        value: theme.id,
        checked: checked,
        onChange: (e, data) => {
          if (data.checked && !checked) {
            setFilter('themeIds', [...themeIdsFilter, theme.id]);
            setFilter('categoryIds', [...categoryIdsFilter, ...theme.children]);
          } else if (!data.checked && checked) {
            setFilter('themeIds', themeIdsFilter.filter(item => item !== theme.id));
            setFilter('categoryIds', categoryIdsFilter.filter(item => theme.children.indexOf(item) === -1));
          }
        }
      }));
    })))) : null;
  })), /*#__PURE__*/React.createElement("hr", null)) : null;
};
export default Filters;